import React from "react";
import { Typography } from "components/SemanticComponents";

export default function Text({ item }) {
  const { text } = JSON.parse(item.data);
  return <Typography.Paragraph level="p2">{text}</Typography.Paragraph>;
}
